import React, { useCallback, useMemo } from 'react';
import { WithStyles } from '@material-ui/core';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Typography from '#web-components/components/Typography';
import IconButton from '#web-components/components/IconButton';
import Autocomplete from '#web-components/components/FormControls/Autocomplete';
import { ItemProps } from '#web-components/components/FormControls/Autocomplete/Autocomplete';
import styles from './HeaderWithYearPicker.styles';

export interface Props extends ReactDatePickerCustomHeaderProps, WithStyles<typeof styles> {
  locale: string,
  onYearOpenChange: (state: boolean) => void,
}
const arrayRange = (start: number, stop: number, step: number) => Array.from(
  { length: (stop - start) / step + 1 },
  (value, index) => start + index * step,
);
const YEAR_PICKER_RANGE = 100;

const HeaderWithYearPicker = (props: Props) => {
  const {
    decreaseMonth,
    increaseMonth,
    date,
    monthDate,
    changeYear,
    classes,
    locale,
    onYearOpenChange,
  } = props;

  const selectYear = (year: unknown) => {
    const myYear = year as ItemProps;
    changeYear(new Date(myYear.value).getFullYear());
  };

  const yearOptions = useMemo(() => {
    const year = date.getFullYear();
    return arrayRange(year - YEAR_PICKER_RANGE, year + YEAR_PICKER_RANGE, 1)
      .map((el) => ({ value: el.toString(), label: el.toString() }));
  }, [date]);

  const currentSelectValue = useMemo(() => {
    return { value: date.getFullYear().toString(), label: date.getFullYear().toString() };
  }, [date]);

  const handleYearOpen = useCallback(() => {
    onYearOpenChange(true);
  }, [onYearOpenChange]);
  const handleYearClose = useCallback(() => {
    onYearOpenChange(false);
  }, [onYearOpenChange]);

  return (
    <div className={classes['react-datepicker__custom-header']}>
      <div className="react-datepicker__custom-header__month">
        <IconButton size="medium" className={classes.monthButtons} onClick={decreaseMonth}>
          <ChevronLeftIcon />
        </IconButton>
        <Typography variant="textRegular" className={classes.monthText}>
          {monthDate.toLocaleString(locale, {
            month: 'long',
          })}
        </Typography>
        <IconButton size="medium" className={classes.monthButtons} onClick={increaseMonth}>
          <ChevronRightIcon />
        </IconButton>
      </div>
      <Autocomplete
        name="year"
        value={currentSelectValue}
        options={yearOptions}
        onChange={selectYear}
        hiddenLabel
        size="small"
        disablePortal
        classes={{
          clearIndicator: classes.clearIndicator,
          popper: classes.yearPopper,
          paper: classes.yearPaper,
          input: classes.yearInput,
          inputRoot: classes.yearInputRoot,
          endAdornment: classes.yearIcons,
        }}
        onOpen={handleYearOpen}
        onClose={handleYearClose}
      />
    </div>
  );
};

export default HeaderWithYearPicker;
